import React, { Component, useEffect, useState } from "react";
import { Table, Icon, Spin, Tag } from "antd";
import { connect, useDispatch, useSelector } from "react-redux";

import { Button, Modal } from '../../helpers/commonUi'

import App from "./App";
import style from "./list.module.sass";
import nodataImg from "../../assets/images/create_apps.svg";

import { ReactComponent as TableEdit } from '../../assets/svg/editIcon.svg'
import { ReactComponent as PolicyIcon } from '../../assets/svg/policyIcon.svg'
import { ReactComponent as Delete } from '../../assets/svg/delete.svg'

import {
  deleteApps,
  removeSelectedOrg,
  updateAppsList,
  updateSelectedApp,
  updateAppBranch
} from "../../stateManager/store/apps/actions";

import { setGuideVisible, setStepIndex } from "../../stateManager/store/onboarding/action";

import { pushToast } from "../../stateManager/store/toast/actions";

import { Http } from "../../helpers/axois";

import { AttachPolicies } from './AttachPolicies'

import NoData from './NoData'
import { ReactComponent as WarningIcon } from '../../assets/svg/warningIcon.svg'
import { ReactComponent as Placeholder_Icon } from "../../assets/svg/Placeholder_Icon.svg";
import { ReactComponent as BrokenImage_Icon } from "../../assets/svg/BrokenImage_Icon.svg";
import { ImportApp } from "../marketplace/apps/appImport/ImportApps";
import { AppState } from "../../stateManager/store";
import { GCPENDPOINT } from "../../constant/common";
import SearchBar , { highlightMatch } from "../../helpers/SearchBar";

interface IsValidImage {
  [key: string]: boolean;
}

interface State {
  visible: boolean;
  loading: boolean;
  editInitialData: any;
  editable: boolean;
  list: [];
  editvisible: boolean;
  deleteModalVisible: boolean;
  deleteData: any;
  policyVisible: boolean;
  policyData: {};
  canViewApp: boolean;
  callGetApps: boolean;
  isValidImage: IsValidImage;
  filteredData: any[];
  searchValue: string;
  searchRef: React.RefObject<{ clearSearch: () => void }>
}
interface Props {
  list: any[];
  history?: any;
  deleteApps: (data: any) => void;
  selectedOrg: any;
  orgPermissions: any;
  capabilities: any;
  removeSelectedOrg: () => void;
  pushToast: (data: any) => void;
  updateAppsList: (data: any) => void;
  updateSelectedApp: (data: any) => void;
  updateAppBranch: any;
  setGuideVisible: (data: any) => void;
  setStepIndex: (data: any) => void;
  stepIndex: number
}

const antIcon = <Icon type="loading" style={{ fontSize: 24, color: "#15808C" }} spin />;

class AppList extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      visible: false,
      list: [],
      editInitialData: {},
      editable: false,
      editvisible: false,
      loading: true,
      deleteModalVisible: false,
      deleteData: {},
      policyVisible: false,
      policyData: {},
      canViewApp: true,
      callGetApps: false,
      isValidImage: {},
      filteredData: [],
      searchValue:"",
      searchRef: React.createRef()
    };
  }

  componentDidMount() {
    if (this.props.selectedOrg.id) {
      // this.setState({
      //   editvisible: true,
      //   editInitialData: { Orgnaisation: this.props.selectedOrg },
      //   editable: true
      // });
      // this.props.removeSelectedOrg();
      this.getApps();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.selectedOrg.id !== prevProps.selectedOrg.id) {
      this.getApps();
    }
    if (this.state.callGetApps) {
      this.getApps()
    }
  }

  getApps() {
    this.state.searchRef.current?.clearSearch()
    this.setState({ callGetApps: false })
    Http.get(`org/${this.props.selectedOrg.id}/apps`).subscribe((appRes: any) => {
      this.props.updateAppsList && this.props.updateAppsList(appRes)
      this.setState({
        loading: false,
        list: appRes,
        isValidImage: {
          id: true,
        },
        canViewApp: true,
        filteredData: appRes
      })
    }, (err) => {
      if (err === 'Forbidden') {
        this.setState({
          canViewApp: false
        })
      } else {
        this.setState({
          canViewApp: true,
        })
      }
      this.setState({
        loading: false,
        list: [],
        filteredData: []
      })
    });
  }

  deleteApps(id: string) {
    Http.delete(`/apps/${id}`).subscribe((res) => {
      this.getApps();
      this.props.pushToast(
        { type: 'success', message: 'App deleted successfully' }
      )
    }, (err) => {
      this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : 'App deletion failed' }
      )
    });
  }

  handleImageError = (id: string) => {
    this.setState((prevState) => ({
      isValidImage: {
        ...prevState.isValidImage,
        [id]: false,
      },
    }));
  };

  handleImageLoad = (id: string) => {
    this.setState((prevState) => ({
      isValidImage: {
        ...prevState.isValidImage,
        [id]: true,
      },
    }));
  };

  getBpmns(appId: string, versionId: string): Promise<Record<string, any>[]> {
    this.setState({ loading: true });

    return new Promise((resolve, reject) => {
      if (!versionId) {
        resolve([]);
        return;
      }

      Http.get(`/apps/${appId}/bpmn?versionId=${versionId}`).subscribe(
        (formRes: any) => {
          this.setState({ loading: false });
          if (Array.isArray(formRes) && formRes.length > 0) {
            resolve(formRes);
          } else {
            resolve([]);
          }
        },
        (err: any) => {
          this.setState({ loading: false });
          this.props.history.push("/apps/list");
          reject(err);
        }
      );
    });
  }

  getSolo(appId: string, versionId: string): Promise<Record<string, any>[]> {
    this.setState({ loading: true });

    return new Promise((resolve, reject) => {
      if (!versionId) {
        resolve([]);
        return;
      }

      Http.get(`/apps/${appId}/solo-flows?versionId=${versionId}`).subscribe(
        (formRes: any) => {
          this.setState({ loading: false });
          if (Array.isArray(formRes?.flows) && formRes?.flows?.length > 0) {
            resolve(formRes?.flows);
          } else {
            resolve([]);
          }
        },
        (err: any) => {
          this.setState({ loading: false });
          this.props.history.push("/apps/list");
          reject(err);
        }
      );
    });
  }

  render() {
    const orgPermissions = this.props.orgPermissions
    const canEditApp = orgPermissions.includes('app.Edit')
    const canDeleteApp = orgPermissions.includes('app.Delete')
    const canCreateApp = orgPermissions.includes('app.Create')
    const canViewPolicy = orgPermissions.includes('policy.View')
    const canAttachPolicy = orgPermissions.includes('policy.Attach')
    const canRemovePolicy = orgPermissions.includes('policy.Remove')
    const canViewTeam = orgPermissions.includes('team.View')
    const canViewApp = this.state.canViewApp

    const { list } = this.state;

    const columns = [
      {
        title: "Display Name",
        dataIndex: "displayName",
        key: "displayName",
        render: (name:any, obj:any) => {
          const dataUrl = obj?.avatar || "";
          const imageId = obj?.appId;
          let formattedValue = highlightMatch(name, this.state.searchValue)
          return (
            <div className="flex flex-row gap-2 items-center">
              <div>
                {dataUrl ?
                  this.state.isValidImage[imageId] !== false ?
                    <img
                      style={{ width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #EEEEEE" }}
                      src={`${dataUrl.startsWith("https://") ? dataUrl : GCPENDPOINT+dataUrl}`}
                      onError={(e) => { 
                        this.handleImageError(imageId)
                      }}
                      onLoad={() => { this.handleImageLoad(imageId) }}
                      alt="Avatar"
                    />
                    :
                    <BrokenImage_Icon />
                  :
                  <Placeholder_Icon />
                }
              </div>
              <div>
                <p className="m-auto break-all">{formattedValue}</p>
              </div>
            </div>
          );
        }
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "appName",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Organization",
        dataIndex: "orgName",
        key: "Organization",
        render: (value: string)=>{
          let formattedValue = highlightMatch(value, this.state.searchValue)
          return formattedValue
        }
      },
      {
        title: "Type",
        dataIndex: "type",
        key: "appType",
        render: (text: any, record: any) => {
          let style: Record<string, string> = {}
          let formattedValue = highlightMatch(text, this.state.searchValue)
          if(text === 'a8chat') {
            style.color = '#00B796';
            style.border = '1px solid #8BDECF';
            style.background = '#EEFFFC';
          }
          return <Tag style={style} color={text === 'a8flow' ? 'blue' : 'orange'}>{formattedValue}</Tag>
        }
      },
      {
        title: "Actions",
        key: "actions",
        render: (text: any, record: any) => (
          <div className="action">
            <span
              data-test-id="action_policy"
              title="Policy"
              className="action-icon policy-icon"
              onClick={e => {
                e.stopPropagation();
                const canEditAppLocal = record.permissions.includes('app.Edit')
                const canViewPolicyLocal = record.permissions.includes('policy.View')
                const canAttachPolicyLocal = record.permissions.includes('policy.Attach')
                const canRemovePolicyLocal = record.permissions.includes('policy.Remove')
                const canViewTeamLocal = record.permissions.includes('team.View')
                if ((canEditApp || canEditAppLocal) && (canViewPolicy || canViewPolicyLocal) && (canViewTeam || canViewTeamLocal) && (canAttachPolicy || canAttachPolicyLocal || canRemovePolicy || canRemovePolicyLocal)) {
                  this.setState({
                    policyVisible: true,
                    policyData: {
                      ...record,
                      canAttach: canAttachPolicy || canAttachPolicyLocal,
                      canRemove: canRemovePolicy || canRemovePolicyLocal
                    },
                  });
                } else {
                  this.props.pushToast(
                    { type: 'error', message: 'You are not authorized to change policies of this app' }
                  )
                }
              }}
            >
              <PolicyIcon style={{ color: "#292D32" }} height='15px' width='15px' />
            </span>
            <span
              data-test-id="action_edit"
              title="Edit"
              className="action-icon edit-icon"
              onClick={e => {
                e.stopPropagation();
                const canEditAppLocal = record.permissions.includes('app.Edit')
                if (canEditApp || canEditAppLocal) {
                  this.setState({
                    editvisible: true,
                    editInitialData: record,
                    editable: true
                  });
                } else {
                  this.props.pushToast(
                    { type: 'error', message: 'You are not authorized to edit this app' }
                  )
                }
              }}
            >
              <TableEdit data-test-id="table" height='15px' width='15px' />
            </span>
            {this.state.list.length >= 1 && (
              <span
                data-test-id="action_delete"
                title="Delete"
                className="action-icon delete-icon"
                onClick={e => {
                  e.stopPropagation();
                  const canDeleteAppLocal = record.permissions.includes('app.Delete')
                  if (canDeleteApp || canDeleteAppLocal) {
                    this.setState({
                      deleteData: record,
                      deleteModalVisible: true,
                      searchValue: "",
                      filteredData: this?.state?.list || []
                    });
                  } else {
                    this.props.pushToast(
                      { type: 'error', message: 'You are not authorized to this delete app' }
                    )
                  }
                }}
              >
                <Delete height='15px' width='15px' />
              </span>
            )}
          </div>
        )
      }
    ];

    return (
      canViewApp ?
        <React.Fragment>
          {list && list.length > 0 ? (
            <div className={"tour_create_app_step--observe row " + style.data} >
              <div className={style.header}>
                <div className={style.first}>
                  <h4>Apps</h4>
                  <h5>View, edit or create a new app</h5>
                </div>
                <div className="flex align-items" style={{height:"36px"}}>
                  <SearchBar
                    ref={this.state.searchRef}
                    data={this.state.list}
                    columns={columns}
                    onFilter={(filteredData ) => {
                      this.setState({
                        filteredData: filteredData,
                      })
                    }}
                    onSearchTermChange={ (searchValue: string)=>{ this.setState({searchValue: searchValue}) } }
                  />
                  {!this.props.capabilities && <ImportApp key={this.props.selectedOrg.id} callGetApps={val => {
                    this.setState({ callGetApps: val });
                  }} />}
                  {
                    canCreateApp &&
                    (
                      <Button className={'tour_create_app_step'} dataTestId="create_apps" size="small" 
                      style={{backgroundColor: "#15808C"}}
                      onClick={() => {
                        this.setState({ visible: true }) 
                        setTimeout(()=>{
                          this.props.setStepIndex(this.props.stepIndex + 1)
                        }, 300)
                      } }>
                        CREATE APP
                      </Button>
                    )
                  }
                </div>
              </div>
              <div className={style.container + " container-fluid"}>
                <Table
                  pagination={false}
                  scroll={{ y: 'calc(100vh - 240px)' }}
                  columns={columns}
                  onRow={(record: any, rowIndex: any) => {
                    return {
                      'data-test-id': 'app_table_row_' + record.key,
                      onClick: async(event: any) => {
                        let target: any = event.target;
                        if (target.tagName !== "A") {
                          this.props.updateSelectedApp({
                            id: record.appId,
                            name: record.name,
                            type: record.type,
                            permissions: record.permissions,
                            displayName: record?.displayName
                          })
                          this.props.updateAppBranch({
                            key: record.appId,
                            value: {
                              branchName: record && record.branches && record.branches[0] && record.branches[0]["f2"],
                              branchId: record && record.branches && record.branches[0] && record.branches[0]["f1"]
                            }
                          })
													this.props.history.push("/apps/list/" + record.appId + ((record.type === "a8solo" || record.type === "a8chat" ) ? "/journey/solo/list" : "/journey/assist/list"));
                          // let route: string | null = null;
                          // const versionId = record   && record.branches && record.branches[0] && record.branches[0]["f5"]
                          // if ((record.type === "a8solo" || record.type === "a8chat") && this.props.capabilities) {
                          //   const soloResponse = await this.getSolo(record.appId, versionId);
                          //
                          //   if (Array.isArray(soloResponse) && soloResponse.length === 1) {
                          //     route = `/apps/list/${record.appId}/journey/solo/list/${soloResponse[0].id}/create`;
                          //   }
                          // } else if (this.props.capabilities) {
                          //   const response = await this.getBpmns(record.appId, versionId);
                          //   if (Array.isArray(response) && response.length === 1) {
                          //     route = `/apps/list/${record.appId}/journey/assist/list/${response[0].bpmnId}/create`;
                          //   }
                          // }
                          // this.props.history.push(route || "/apps/list/" + record.appId + ((record.type === "a8solo" || record.type === "a8chat") ? "/journey/solo/list" : "/journey/assist/list"))
                        }
                      }
                    };
                  }}
                  className='override-table-container-app'
                  dataSource={this.state.filteredData.map((res: any, key: number) => {
                    return { ...res, key: key };
                  })}
                />
              </div>
            </div>
          ) : (this.state.loading) ? null : (<AppNodata
            key={this.props.selectedOrg.id}
            getApps={this.getApps}
            toast={this.props.pushToast}
            canCreate={canCreateApp}
            callGetApps={val => {
              this.setState({ callGetApps: val });
            }}
            setvisible={status => {
              this.setState({ visible: status });
            }}
            capabilities={this.props.capabilities}
          />)}

          {
            (this.state.loading) ? <div className={style.loadingSpinner}>
              <Spin indicator={antIcon} style={{ color: '#15808C' }} />
            </div> : null
          }


          <AppModel
            visible={this.state.visible}
            getApps={() => this.getApps()}
            setvisible={status => {
              this.setState({
                visible: status
              });
            }}
          />
          {this.state.editvisible && (
            <AppModel
              visible={this.state.editable}
              getApps={() => this.getApps()}
              setvisible={status => {
                this.setState({
                  editable: status,
                  editInitialData: {}
                });
                setTimeout(() => {
                  this.setState({ editvisible: false });
                }, 400);
              }}
              editable={this.state.editable}
              initialdata={this.state.editInitialData}
            />
          )}

          <Modal
            id="deleteApp"
            dataTestId="delete_app"
            unmountOnCancel={true}
            visible={this.state.deleteModalVisible}
            title="DELETE APP"
            onCancel={() => {
              this.setState({
                deleteModalVisible: false,
                deleteData: {}
              })
            }}
            deleteOptions={{
              type: "App",
              validateString: this.state.deleteData.name
            }}
            footer={{
              enable: true,
              okText: 'DELETE',
              cancelText: 'CANCEL',
              onOk: () => {
                this.deleteApps(this.state.deleteData.appId)
                this.setState({
                  deleteModalVisible: false
                })
              }
            }}
          />

          <Modal
            width="650px"
            id="attachAppPolicies"
            dataTestId="attach_app_policies"
            unmountOnCancel={true}
            visible={this.state.policyVisible}
            title="ATTACH POLICIES"
            onCancel={() => {
              this.setState({
                policyVisible: false,
                policyData: {}
              })
            }}
            footer={{
              enable: false
            }}
          >
            <AttachPolicies data={this.state.policyData} />
          </Modal>

        </React.Fragment>
        :
        <NoData
          svg={WarningIcon}
          header='Not Authorized'
          content='Please request owner of this organization to provide access'
          noButton={true}
        />
    );
  }
}
interface AppmodelProps {
  visible: boolean;
  getApps: () => void;
  setvisible: (status: boolean) => void;
  editable?: boolean;
  initialdata?: {};
}
const AppModel = ({
  visible,
  setvisible,
  editable,
  getApps,
  initialdata
}: AppmodelProps) => {
  let onSubmit: any;
  const dispatch = useDispatch()
  return (
    <Modal
      id="editCreateApp"
      dataTestId="edit_create_app"
      title={initialdata ? 'EDIT APP' : 'CREATE APP'}
      visible={visible}
      className={'app_cre_mdl'}
      unmountOnCancel={true}
      footer={{
        enable: false,
      }}
      onCancel={() => {
        setvisible(false);
        dispatch(setGuideVisible(false))
      }}
    >
      <App
        getApps={getApps}
        editable={editable}
        initialdata={initialdata}
        onSubmit={(submit: any) => {
          onSubmit = submit;
          submit(setvisible);
        }}
        okText={ editable ? "SAVE" : "CREATE"}
        cancelText= {"CANCEL"}
        onCancel={() => {
          setvisible(false);
          dispatch(setGuideVisible(false))
        }}
      />
    </Modal>
  );
};
interface AppNodataProps {
  setvisible: (status: boolean) => void;
  canCreate: boolean;
  toast: (data: any) => void;
  getApps: () => void;
  callGetApps: (val: boolean) => void
  capabilities: any
}
const AppNodata = ({ setvisible, canCreate, toast, getApps, callGetApps, capabilities }: AppNodataProps) => {
  const [isRender, setRender] = useState(false)
  const dispatch = useDispatch();
  const { stepIndex } = useSelector((state: AppState) => state.onboarding.info)
  useEffect(() => {
    if (isRender) {
      setRender(false)
    }
  }, [isRender])

  return (
    <div className={"row " + style.nodata}>
      <div className={"col-md-4 " + style.first}>
        <h4 className={style.header}>Build Apps</h4>
        <h5 className={style.subHeader}>
          Build powerful apps with clear docs and with simple tools
        </h5>
        <Button className={"tour_create_app_step"} dataTestId="build_apps" size="large" color="shadow-secondary" onClick={() => {
          if (canCreate) {
            setvisible(true)
            dispatch(setStepIndex(stepIndex + 1))
          } else {
            toast({
              type: 'error',
              message: 'You are not authorized to create apps'
            })
          }
        }}>
          BUILD APPS
        </Button>
      </div>
      <div className={"col-md-8 " + style.second}>
        <img src={nodataImg} alt="" />
        {!capabilities && <ImportApp setRender={setRender} render={isRender} callGetApps={callGetApps} />}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    selectedOrg: state.org.selectedOrg,
    orgPermissions: state.org.orgPermissions,
    stepIndex: state.onboarding.info.stepIndex,
    capabilities: state.user.userDetails.capabilities
  };
};

export default connect(
  mapStateToProps,
  { deleteApps, removeSelectedOrg, pushToast, updateAppsList, updateSelectedApp, updateAppBranch, setGuideVisible, setStepIndex }
)(AppList);
